import { SiteConfiguration } from '../types';

// Simple in-memory storage for site configurations
// In a real app, this would be replaced with API calls to a backend
class SiteConfigStorage {
  private configurations: Map<string, SiteConfiguration> = new Map();
  private listeners: Set<(projectId: string) => void> = new Set();

  // Subscribe to configuration changes
  subscribe(listener: (projectId: string) => void): () => void {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }

  // Notify all listeners of a configuration change
  private notifyListeners(projectId: string): void {
    this.listeners.forEach(listener => listener(projectId));
  }

  saveConfiguration(projectId: string, nodes: any[], edges: any[]): SiteConfiguration {
    const config: SiteConfiguration = {
      id: `config-${projectId}`,
      projectId,
      name: 'Site Configuration',
      nodes,
      edges,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    };

    this.configurations.set(projectId, config);
    this.notifyListeners(projectId);
    return config;
  }

  getConfiguration(projectId: string): SiteConfiguration | null {
    return this.configurations.get(projectId) || null;
  }

  getConfigurations(projectId: string): SiteConfiguration[] {
    const config = this.configurations.get(projectId);
    return config ? [config] : [];
  }

  deleteConfiguration(projectId: string): boolean {
    const deleted = this.configurations.delete(projectId);
    if (deleted) {
      this.notifyListeners(projectId);
    }
    return deleted;
  }
}

// Export a singleton instance
export const siteConfigStorage = new SiteConfigStorage();
